import React from "react";
import { NavLink } from "react-router-dom";
import monuments, { getDeviceType, textmapping } from "../../helper";

function Effects(props) {
  return (
    <section className="chooseimg_section" id="effects_choosing_section">
      <div className="container" style={{ marginBottom: "50px" }}>
        <div className="chooseimg_bg">
          <p>
            Today, Prime Minister Modi and 140 crore Indians stand united in
            their commitment to advance the vision of 'Hamara Sankalp Viksit
            Bharat.' Let us showcase our dedication by capturing a Viksit Bharat
            selfie with PM Modi, and inspire others to join the movement towards
            the realization of a developed India—a 'Viksit Bharat'.
          </p>

          <div className="row">
            <div className="col-sm-12">
              <ul className="chooseimg_list">
                {/* {monuments?.length > 0 &&
              monuments?.map((img, index) => {
                if (index < 3) {
                  return ( */}
                <li>
                  <img
                    src={"/assets/images/1.jpeg"}
                    className="rounded"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src={"/assets/images/2.jpeg"}
                    className="rounded"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src={"/assets/images/3.jpeg"}
                    className="rounded"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src={"/assets/images/4.jpeg"}
                    className="rounded"
                    alt=""
                  />
                </li>
                {/* );
                }else {
                  return <></>
                }
              })} */}
                {/* <li>
                  <img
                    src={
                      props.lang == "gu"
                        ? "/assets/images/gujarat1.jpg"
                        : "/assets/images/english1.jpg"
                    }
                    className="rounded"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src={
                      props.lang == "gu"
                        ? "/assets/images/gujarat2.jpg"
                        : "/assets/images/english2.jpg"
                    }
                    className="rounded"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src={
                      props.lang == "gu"
                        ? "/assets/images/gujarat3.jpg"
                        : "/assets/images/english3.jpg"
                    }
                    className="rounded"
                    alt=""
                  />
                </li> */}
              </ul>
              <NavLink
                to={`/uploadimage/monuments${window.location.search}`}
                className="monument_btn"
                onClick={() => {
                  try {
                    let obj = {
                      platform: getDeviceType(),
                    };
                    window.gtag("event", "Create Selfie", obj);
                  } catch (error) {}
                }}
              >
                <img
                  src="/assets/images/monument.svg"
                  className="monument_blue"
                  alt=""
                />
                <img
                  src="/assets/images/monumentwhite.svg"
                  className="monument_white"
                  alt=""
                />
                {textmapping("Create Selfie")}
              </NavLink>
            </div>

            {/* <div className="col-sm-2 or_text_position">
              <h6 className="or_text">OR</h6>
            </div> */}

            {/* <div className="col-sm-5">
              <ul className="chooseimg_list">
                <li>
                  <img
                    src="/assets/images/img-22.jpg"
                    className="rounded"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="/assets/images/img-23.jpg"
                    className="rounded"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="/assets/images/img-24.jpg"
                    className="rounded"
                    alt=""
                  />
                </li>
              </ul>
              <NavLink to={`/uploadimage/effects`} className="monument_btn"
              // onClick={() => {
              // if (props.page == 'home') {

              // try {
              //     let obj = {
              //         platform: getDeviceType()
              //     }
              //     window.gtag('event', 'choose_effect_home', obj)
              // } catch (error) {

              // }
              // }

              // }}
              >
                <img
                  src="/assets/images/face.svg"
                  className="monument_blue"
                  alt=""
                />
                <img
                  src="/assets/images/facewhite.svg"
                  className="monument_white"
                  alt=""
                />
                Choose Effects
              </NavLink>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Effects;
